<template>
  <div>
    <el-drawer
      custom-class="el-drawer-deal el-drawer-credit  outline_right"
      :visible.sync="rightInfoSync"
      size="840px"
      class="outlineInfo"
      v-if="rightInfoSync"
      :show-close="true"
      @close="closeDrawer"
    >
      <div slot="title">
        <dealTitle :data="getByIdFullData" :statusShow="false" ></dealTitle>
      </div>
      <commonReportInfo :data="getByIdFullData">
        <div slot="other">
          <el-form-item label="举报人：">{{getByIdFullData.creatuser}}</el-form-item>
          <el-form-item label="举报时间：">{{getByIdFullData.createtime|fullTime}}</el-form-item>
        </div>
      </commonReportInfo>
      <!-- 处理信息 -->
      <div class="drawer-subtitle_common">
        <span class="drawer-subtitle-text">结果信息</span>
      </div>
      <el-card>
        <el-form label-width="100px">
          <el-form-item label="结果说明：">{{getByIdFullData.result}}</el-form-item>
          <!-- <el-form-item label="处理说明：">{{getByIdFullData.decisions}}</el-form-item>
          <el-form-item
            label="处理人："
            v-show="loginType!=='SHOP'&&loginType!=='DEALER'"
          >{{getByIdFullData.flowusername}}</el-form-item>
          <el-form-item label="处理时间：">{{getByIdFullData.updatetime|fullTime}}</el-form-item> -->
        </el-form>
      </el-card>
      <!-- 积分处理 -->
      <el-row class="info_header">
        <el-col :span="19">
          <div class="drawer-subtitle_common">
            <span>积分处理</span>
          </div>
        </el-col>
        <el-col :span="5">
          <el-link
            type="primary"
            :underline="false"
            class="margin_top20"
            @click="showSelectDeal=false"
            v-if="selectDeal"
          >修改积分处理信息</el-link>
        </el-col>
      </el-row>
      <el-card>
        <div class="hint_word_orange" v-show="!showSelectDeal">
          <div class="f14">
            <i class="el-icon-warning"></i>店铺违规情况，请注意！
          </div>
          <div
            class="f12"
          >本店铺当前信用积分周期内剩余积分 {{getByIdFullData.currentSurplusScore?getByIdFullData.currentSurplusScore:0}} 分，上个积分周期内剩余{{getByIdFullData.lastSurplusScore?getByIdFullData.lastSurplusScore:0}} 分。</div>
          <div
            class="f12"
          >本店铺当前积分周期已确认该链接违规 {{getByIdFullData.linkSurplusCount?getByIdFullData.linkSurplusCount:0}} 次，同款产品违规 {{getByIdFullData.productSurplusCount?getByIdFullData.productSurplusCount:0}} 次。</div>
        </div>
        <el-form label-width="120px">
          <el-form-item label="扣信用积分：" :required="true">
            <span v-if="showSelectDeal">{{getByIdFullData.points}}</span>
            <el-input
              placeholder="请输入不小于0的数值，小数点后一位有效数字"
              size="small"
              class="deal_input"
              v-model="deductLine.points"
              v-limitInput
              v-else
              @input="changePoints"
            ></el-input>
          </el-form-item>
          <el-form-item label="附加处罚：">
            <span v-if="showSelectDeal">{{getByIdFullData.punish}}</span>
            <el-input
              size="small"
              class="deal_input"
              v-model="deductLine.punish"
              v-else
              @input="changePunish"
            ></el-input>
          </el-form-item>
          <el-form-item label="扣分说明：" style="margin-top:10px">
            <span v-if="showSelectDeal">{{getByIdFullData.pointsexplains}}</span>
            <el-input
              type="textarea"
              class="common_textarea"
              size="small"
              v-model="deductLine.pointsexplains"
              v-else
              @input="changePointsexplains"
            ></el-input>
          </el-form-item>
          <el-form-item label="扣分人：" v-if="selectDeal&&showSelectDeal">
            <span>{{getByIdFullData.handle}}</span>
          </el-form-item>
          <el-form-item label="扣分时间：" v-if="selectDeal&&showSelectDeal">
            <span>{{getByIdFullData.pointtime|fullTime}}</span>
          </el-form-item>
        </el-form>
      </el-card>
      <div class="flex_end margin_top20" v-show="!showSelectDeal">
        <el-button type="confire_btn" size="small" @click="cancelConfire">确定</el-button>
        <el-button type="cancel_blue" size="small" @click="closeDrawer">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import commonReportInfo from "views/CreditScore/common/commonReportInfo";
import dealTitle from "views/CreditScore/common/dealMainInfo/dealTitle";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import { getLoginType } from "@/libs/until";
import { keydown } from "@/libs/commonMethod";
import { fetchGet, fetchPost } from "@/libs/reqCommon";

export default {
  props: {
    selectDeal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rightInfoSync: false,
      rightDate: {},
      //扣分处理
      deductLine: {
        points: "",
        punish: "",
        pointsexplains: ""
      },
      showSelectDeal: false,
      loginType: getLoginType()
    };
  },
  components: { commonReportInfo, dealTitle },
  computed: {
    ...mapGetters(["getByIdFullData"])
  },
  methods: {
    changePointsexplains(val) {
      this.deductLine.pointsexplains = val;
      this.$forceUpdate();
    },
    changePunish(val) {
      this.deductLine.punish = val;
      this.$forceUpdate();
    },
    changePoints(val) {
      this.deductLine.points = val;
      this.$forceUpdate();
    },
    closeDrawer() {
      this.deductLine = {};
      this.rightInfoSync = false;
    },
    showDeal() {
      this.deductLine.points = Number(this.getByIdFullData.points);
      this.deductLine.punish = this.getByIdFullData.punish;
      this.deductLine.pointsexplains = this.getByIdFullData.pointsexplains;
    },
    cancelConfire() {
      // if (!this.deductLine.points.replace(/\s/g, "")) {
      if (!this.deductLine.points && this.deductLine.points != '0') {
        this.$message.error("请输入扣信用积分");
        return false;
      }
      this.deductLine.points = Number(this.deductLine.points);
      let pointsList = [{ ...this.deductLine }];
      this.insertPoints(pointsList);
    },
    //第一次扣分
    insertPoints(pointsList) {
      if (!this.getByIdFullData.points) {
        pointsList[0].reportid = this.getByIdFullData.reportid;
        fetch({
          method: "POST",
          url: "/hcm/hcmReport/insertPoints",
          data: JSON.stringify(pointsList),
          headers: {
            "Content-Type": "application/json"
          }
        }).then(res => {
          if (res.status === "10000") {
            this.$message.success("成功");
            this.rightInfoSync = false;
            this.$emit("loadPage");
          }
        });
      } else {
        pointsList[0].id = this.getByIdFullData.pointsid;
        fetchPost("/hcm/hcmReport/updatePoints", pointsList[0]).then(res => {
          if (res.status === "10000") {
            this.$message.success("成功");
            this.rightInfoSync = false;
            this.$emit("loadPage");
          }
        });
      }
    }
  }
};
</script>
<style lang="scss">
@import "style/fontSize.scss";
.outline_right {
  .hint_word_orange {
    width: 83.5%;
    margin-bottom: 10px;
  }
}
.outlineInfo {
  .el-drawer__body {
    padding: 0 20px 20px 20px !important;
  }
  .el-drawer__header {
    // margin-bottom: 0;
  }
  .common_textarea .el-textarea__inner,
  .deal_input {
    width: 80%;
  }
  .el-drawer .el-drawer__header .el-icon-close {
    display: block;
  }
}
</style>
